
import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import AnimateInView from '@/components/ui/animate-in-view';
import GoldSectionDivider from '@/components/ui/gold-section-divider';

const FenceOverview = () => {
  return (
    <section className="section bg-white" aria-labelledby="fence-overview-heading">
      <div className="container mx-auto">
        <div className="flex flex-col items-center mb-8">
          <GoldSectionDivider centered />
          <h2 id="fence-overview-heading" className="text-boundri-DEFAULT mb-2">
            What It Is
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
          <AnimateInView animation="slide-up" delay={200}>
            <div>
              <p className="mb-4 text-lg text-boundri-charcoal">
                The <strong>On-Fence Sentinel Cable</strong> is a patented system that wraps around existing fences, detecting <strong>climbing, cutting, or tampering</strong> with unmatched precision.
              </p>
              <p className="mb-6 text-boundri-charcoal">
                With <strong>5000 sensitivity levels</strong>, it responds to threats while ignoring harmless touch (e.g., birds, trees brushing). The system transforms ordinary boundaries into intelligent security perimeters.
              </p>
              
              {/* Added visual stats for CRO */}
              <div className="grid grid-cols-3 gap-4 mb-6">
                <div className="text-center p-3 bg-boundri-background rounded-lg">
                  <div className="text-2xl font-bold text-forti-fi-teal">99.8%</div>
                  <div className="text-sm text-boundri-charcoal">Detection Rate</div>
                </div>
                <div className="text-center p-3 bg-boundri-background rounded-lg">
                  <div className="text-2xl font-bold text-forti-fi-teal">5000</div>
                  <div className="text-sm text-boundri-charcoal">Sensitivity Levels</div>
                </div>
                <div className="text-center p-3 bg-boundri-background rounded-lg">
                  <div className="text-2xl font-bold text-forti-fi-teal">24/7</div>
                  <div className="text-sm text-boundri-charcoal">Monitoring</div>
                </div>
              </div>
              
              <Button asChild className="text-white">
                <Link to="/contact">
                  Request a Demo <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>
          </AnimateInView>
          <AnimateInView animation="fade-in" delay={400}>
            <div className="bg-boundri-lavender/20 rounded-lg overflow-hidden">
              <img alt="On-Fence Detection System" className="w-full h-full object-cover aspect-video" loading="lazy" src="/images/Solutions Fence Hero Section.jpg" />
            </div>
          </AnimateInView>
        </div>
      </div>
    </section>
  );
};

export default FenceOverview;
